import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../../../app.constants';

@Injectable({
  providedIn: 'root'
})
export class ShortageExplorerService {
  private apiUrl = `${AppConstants.API_ENDPOINT}${AppConstants.API.SHORTAGE.SHORTAGE_EXPLORER}`;

  constructor(private http: HttpClient) { }

  getShortageData(payload: any): Observable<any> {
    return this.http.post(this.apiUrl, payload);
  }

  rerunNdc(payload: any): Observable<any> {
    const url = `${AppConstants.API_ENDPOINT}${AppConstants.API.SHORTAGE.RERUN_NDC}`;
    return this.http.post(url, payload);
  }

  getShortageRecordsByIds(payload: any): Observable<any> {
    const url = `${AppConstants.API_ENDPOINT}${AppConstants.API.SHORTAGE.SHORTAGE_RECORDS}`;
    return this.http.post(url, payload);
  }
}
